<template>
  <div class="u-row u-row--sm u-marg-t-lg u-pad-t-md u-center--sm u-marg-t-0--sm">
    <div class="u-w1of12 u-none--sm"></div>
    <anim-scroll :isStagger="true" :key="i" class="keypoints__item u-relative u-w2of12 u-marg-l-1of12 u-pad-x-sm u-pad-t-md t-text--small u-w6of12--sm u-pad-x-0--sm u-left u-marg-t-lg--sm" v-for="i in 3">
      {{ $t('keypoints.point' + i) }}
    </anim-scroll >
  </div>
</template>

<script>
import AnimScroll from '@/components/common/AnimScroll'
export default {
  components: {
    AnimScroll
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.keypoints
  &__item
    &:before
      content ''
      position absolute
      top 0
      left $spacings.sm
      width 50px
      height 4px
      border-radius 2px
      background-color $colors.white
</style>